import { defineSlotRecipe } from '@chakra-ui/react';

/*
 * v3 port notes:
 * - v2's `colorScheme="blackAlpha"` loading strips don't port to
 *   `colorPalette="blackAlpha"`: v3 has no `blackAlpha.solid`/`.muted`
 *   semantic tokens, so the built-in variants fall through to the root `gray`
 *   palette (`gray.900` at 72%) and the bar reads near-black. `neutral` is the
 *   replacement — use it instead of a `colorPalette`.
 * - v2's indeterminate bar was only a gradient (no fill underneath). The
 *   built-in `range` also paints `bgColor: var(--track-color)` under the same
 *   gradient, so `_indeterminate` clears it to keep the fade.
 * - `fg.subtle` is the closest token to v2's `blackAlpha.500` over its
 *   `gray.100` track; `bg.muted` stands in for that track.
 * - The built-in size scale starts at `xs` (6px). `2xs` (4px) is v2's `xs`,
 *   for the page-level loading strips (`BillingPageLoadingBar`).
 */

const progressTheme = defineSlotRecipe({
  slots: ['root', 'track', 'range', 'label', 'valueText'],
  variants: {
    variant: {
      neutral: {
        track: {
          bgColor: 'bg.muted',
        },
        range: {
          '--track-color': 'colors.fg.subtle',
          _indeterminate: {
            bgColor: 'transparent',
          },
        },
      },
    },
    size: {
      '2xs': {
        track: { h: '1' },
      },
    },
  },
});

export default progressTheme;
